import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiKeys } from '../../types/user';

const initialState: ApiKeys = {
  googleAnalytics: '',
  firebase: '',
  marketo: '',
  stripe: '',
  hubspot: '',
  jira: '',
  quickbooks: {
    consumerKey: '',
    consumerSecret: '',
    token: '',
    tokenSecret: '',
    companyId: '',
  },
  openai: '',
};

const apiKeysSlice = createSlice({
  name: 'apiKeys',
  initialState,
  reducers: {
    setApiKeys(state, action: PayloadAction<ApiKeys>) {
      return action.payload;
    },
  },
});

export const { setApiKeys } = apiKeysSlice.actions;
export default apiKeysSlice.reducer;
